import { render, staticRenderFns } from "./UIBanner.vue?vue&type=template&id=94438b36&"
import script from "./UIBanner.vue?vue&type=script&lang=js&"
export * from "./UIBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports